import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { Problem } from './components/Problem';
import { Method } from './components/Method';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Audience } from './components/Audience';
import { Difference } from './components/Difference';
import { Testimonials } from './components/Testimonials';
import { CostOfWaiting } from './components/CostOfWaiting';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { StickyCta } from './components/StickyCta';
interface AppProps {
  showCountdown?: boolean;
  showStickyCta?: boolean;
}
export function App({
  showCountdown = true,
  showStickyCta = true
}: AppProps) {
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0" data-mp="3iiweonbohg2p">
      <TopBar data-id="element-1" data-mp="3mlj98vzqhf3l" />
      <main data-id="element-2" data-mp="3ml13n8r6loj0">
        <Hero data-id="element-3" data-mp="3mkrgdsxitvh0" />
        <StatsStrip data-id="element-4" data-mp="3mk85gw6ag7ch" />
        <Problem data-id="element-5" data-mp="3mjpyb4i388ps" />
        <Method data-id="element-6" data-mp="3mj6lg27aoaim" />
        <Volumes data-id="element-7" data-mp="3rcj846sey78q" />
        <Bonuses data-id="element-8" data-mp="3rbzngibdp4r0" />
        <Offer showCountdown={showCountdown} data-id="element-9" data-mp="3rdkgu4lyihna" />
        <Audience data-id="element-10" data-mp="5yi8qe3h5da" />
        <Difference data-id="element-11" data-mp="6hq1ea16ddl" />
        <Testimonials data-id="element-12" data-mp="4wylxj0jajy" />
        <CostOfWaiting data-id="element-13" data-mp="56lvdcob3ly" />
        <Guarantee data-id="element-14" data-mp="2zl39tfhhuw2o" />
        <Faq data-id="element-15" data-mp="2zlle8zeb8glo" />
        <FinalCta data-id="element-16" data-mp="2zlv3gkrj6jqb" />
      </main>
      <SiteFooter data-id="element-17" data-mp="2zmwi0z7r9ocs" />
      {showStickyCta ? <StickyCta data-id="element-18" data-mp="33moqzd129wio" /> : null}
      {showStickyCta ? <div className="h-16 lg:hidden" aria-hidden="true" data-id="element-19" data-mp="33nggc642ey0i" /> : null}
    </div>;
}